import styled from 'styled-components';
import { Color } from '../../../../constants/Colors';

import { MediaQuery, Transition } from '../../../../constants/Styles';
import { Typography } from '../../../../constants/Typographies';

export const ContentContainer = styled.div`
  max-height: ${({ isVisible }) => (isVisible ? '800px' : '0px')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-top: ${({ isVisible }) => (isVisible ? '40px' : '0px')};

  ${MediaQuery.XL_AND_DOWN} {
    margin-top: 10px;
  }
`;

export const Content = styled.div`
  width: 50%;
  box-sizing: border-box;
  padding: 10px 45px 0px 45px;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 10px 45px 0px 0px;
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 10px 15px 0px 15px;
    width: 100%;
  }
`;

export const ContentTitle = styled.h3`
  ${Typography.XL_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 20px;
`;

export const TextWrapper = styled.div`
  margin-bottom: 20px;

  a {
    color: ${({ customColor }) => customColor || 'default'};
  }

  ul {
    list-style: none;

    li {
      position: relative;
      left: 10px;
    }

    li::before {
      content: url('https://wooclap-content.cdn.prismic.io/wooclap-content/a21ef47b-0f87-4ccc-9e0a-12a1298b8b25_check.svg');
      position: absolute;
      left: -10px;
      transform: translateX(-20px);
      width: 30px;
      height: 30px;
      background: ${({ colorRGB }) => colorRGB || Color.WHISPER};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const IllustrationWrapper = styled.div`
  box-sizing: border-box;
  border-radius: 30px;
  background: ${Color.WHISPER};

  div {
    height: 500px;
    width: 500px;
  }

  ${MediaQuery.XL_AND_DOWN} {
    div {
      height: 300px;
      width: 300px;
    }
  }

  ${MediaQuery.M_AND_DOWN} {
    display: none;
  }
`;
